const PHONE_SEPARATOR_PATTERN = /[\s().-]/g;
const PHONE_INPUT_ALLOWED_CHARACTERS_PATTERN = /[^\d+\s]/g;
const PHONE_INPUT_PLUS_PATTERN = /\+/g;
const PHONE_INPUT_SPACES_PATTERN = /\s+/g;
const ROMANIAN_NATIONAL_PHONE_PATTERN = /^0[2-9]\d{8}$/;
const ROMANIAN_INTERNATIONAL_PHONE_PATTERN = /^\+40[2-9]\d{8}$/;
const INTERNATIONAL_PHONE_PATTERN = /^\+[1-9]\d{7,14}$/;

export const sanitizePhoneNumberInput = (value: string): string => {
  const allowedCharacters = value.replace(PHONE_INPUT_ALLOWED_CHARACTERS_PATTERN, '');
  const hasLeadingPlus = allowedCharacters.trimStart().startsWith('+');
  const phoneWithoutPlus = allowedCharacters
    .replace(PHONE_INPUT_PLUS_PATTERN, '')
    .replace(PHONE_INPUT_SPACES_PATTERN, ' ')
    .trimStart();

  if (hasLeadingPlus) {
    return `+${phoneWithoutPlus}`;
  }

  return phoneWithoutPlus;
};

export const normalizePhoneNumber = (value: string): string => {
  const normalized = value.trim().replace(PHONE_SEPARATOR_PATTERN, '');

  if (normalized.startsWith('00')) {
    return `+${normalized.slice(2)}`;
  }

  return normalized;
};

export const isValidPhoneNumber = (value: string): boolean => {
  const normalized = normalizePhoneNumber(value);

  if (!normalized) {
    return true;
  }

  if (normalized.startsWith('+40')) {
    return ROMANIAN_INTERNATIONAL_PHONE_PATTERN.test(normalized);
  }

  return ROMANIAN_NATIONAL_PHONE_PATTERN.test(normalized) || INTERNATIONAL_PHONE_PATTERN.test(normalized);
};
